// Re-export enums from shared core-types package
export {
  Parties as RoleTypes,
  PartTypes,
  ProjectStatus,
  CompanySideOptions,
  PlanningSideOptions,
  BuildingPlan,
  Risk,
  UsageType,
  FocusTopicsOptions,
  ServiceRoleOptions,
  FoundingYear,
  OfficeSize,
  InternalRole,
  StructureOption,
  BacklogOption,
} from '@arcexperts/core-types'

// Local enum not in core-types
export enum ComplexityDimension {
  CREATIVE = 1,
  TECHNICAL = 2,
  SPACIAL = 3,
  ORGANIZATIONAL = 4,
}

// Local constants not in core-types
export const countryHasServiceRoleOptions = ['CH']
export const countryHasFocusTopicsOptions = ['CH']
